import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import allRoutes from "client/constants/allRoutes";
import { isDemoMode } from "portal/mockData/mockConfig";

const ProtectedRouteAuth = ({ element }) => {
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);

  // Demo preview (hero laptop / Explore Live Demo) is allowed without real auth.
  if (!isAuthenticated && !isDemoMode()) {
    return <Navigate to={allRoutes.login} replace />;
  }

  return element;
};

export default ProtectedRouteAuth;
